module.exports = __webpack_public_path__ + "components/country-flag/static/lv-8035b83ae6c0ea881b9623461b055cec.svg";